/* ============================================
   EIMY ISTOIRE 10th Anniversary — 共通JS
   ============================================ */

(function () {
  'use strict';

  /* ------------------------------------------
     1. スクロールアニメーション（Intersection Observer）
     ------------------------------------------ */
  const ScrollAnimator = {
    /** 監視対象のCSSセレクタ */
    selectors: [
      '.anniv-fade-in',
      '.anniv-fade-in-left',
      '.anniv-fade-in-right',
      '.anniv-fade-only',
      '.anniv-stagger'
    ],

    /** stagger の子要素に遅延を付与する間隔（ms） */
    staggerInterval: 100,

    init() {
      if (!('IntersectionObserver' in window)) {
        // フォールバック：全要素を即座に表示
        this._showAll();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this._reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px'
        }
      );

      const targets = document.querySelectorAll(this.selectors.join(','));
      targets.forEach((el) => observer.observe(el));
    },

    _reveal(el) {
      // stagger の場合、子要素に transition-delay を動的セット
      if (el.classList.contains('anniv-stagger')) {
        Array.from(el.children).forEach((child, i) => {
          child.style.transitionDelay = `${i * this.staggerInterval}ms`;
        });
      }
      el.classList.add('is-visible');
    },

    _showAll() {
      const targets = document.querySelectorAll(this.selectors.join(','));
      targets.forEach((el) => el.classList.add('is-visible'));
    }
  };

  /* ------------------------------------------
     2. スムーススクロール（アンカーリンク）
     ------------------------------------------ */
  const SmoothScroll = {
    init() {
      document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const targetId = link.getAttribute('href');
        if (targetId === '#' || targetId === '#main') return;

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();

        const headerHeight = parseInt(
          getComputedStyle(document.documentElement)
            .getPropertyValue('--anniv-header-height') || '60',
          10
        );

        const top =
          target.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      });
    }
  };

  /* ------------------------------------------
     3. 時限公開チェッカー
     セクション内の [data-publish-at] 要素を監視し、
     公開日時が過ぎたら COMING SOON → 実コンテンツに切替
     ------------------------------------------ */
  const TimedRelease = {
    /** チェック間隔（ms）— 1分ごと */
    checkInterval: 60 * 1000,

    init() {
      this._check();
      setInterval(() => this._check(), this.checkInterval);
    },

    _check() {
      const now = new Date();
      const items = document.querySelectorAll('[data-publish-at]');

      items.forEach((item) => {
        const publishAt = new Date(item.getAttribute('data-publish-at'));
        if (isNaN(publishAt.getTime())) return;

        if (now >= publishAt) {
          // COMING SOON を非表示
          const comingSoon = item.querySelector('.anniv-item-coming-soon');
          if (comingSoon) comingSoon.style.display = 'none';

          // 実コンテンツを表示
          const content = item.querySelector('.anniv-item-content');
          if (content) content.style.display = '';

          // data属性を除去（再チェック不要化）
          item.removeAttribute('data-publish-at');
        }
      });
    }
  };

  /* ------------------------------------------
     4. ヘッダー高さの動的更新
     ヘッダーの実際の高さをCSS変数に反映
     ------------------------------------------ */
  const HeaderHeight = {
    init() {
      const header = document.querySelector('.anniv-header');
      if (!header) return;

      const update = () => {
        const h = header.offsetHeight;
        document.documentElement.style.setProperty(
          '--anniv-header-height',
          h + 'px'
        );
      };

      update();
      window.addEventListener('resize', this._debounce(update, 200));
    },

    _debounce(fn, wait) {
      let timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }
  };

  /* ------------------------------------------
     5. 初期化
     ------------------------------------------ */
  function init() {
    ScrollAnimator.init();
    SmoothScroll.init();
    TimedRelease.init();
    HeaderHeight.init();
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
